(function ($) {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $('#js-council-select').on('change', function () {

        var councilName = this.value;
        var setCouncilSeessionUrl = '/setCouncilName';
        var winUrl = window.location.pathname;
        var $usesLeftEl = $('#js-search-uses-left');
        var $resultsTable = $('#js-single-results-wrap');
        var noSearchResults = $('#js-no-results-message');

        // call a route with the name to set it into session
        $.ajax({
            url: setCouncilSeessionUrl,
            method: 'post',
            data: {'council-name': councilName},
            beforeSend: function () {
                noSearchResults.text('');
                $('#js-ajax-switching-council').fadeIn();
            },
            success: function () {
                $('#js-ajax-switching-council').fadeOut();
            },
            error: function () {
                $('#js-ajax-switching-council').fadeOut();
            }
        }).done(function (data) {
            // session should have council var and be set to the  councils associated DB name

            if($resultsTable.length > 0){
                $resultsTable.fadeOut('5000',function(){
                    $resultsTable.empty();
                });
            }

            if ( winUrl == '/batch-search/saved'){
                window.location.reload();
            }

            // if council selected is in demo mode - show that it is in demo mode
            if (data.hasOwnProperty('demoMode')) {

                var $demoModeSpan = $('#js-mode-indicator');
                var htmlTitle = '<h3 class="panel-title col-lg-6 no-col-pad bold" style="color:turquoise;">DemoMode</h3>';

                // show or hide "Demo mode"
                if (data.demoMode == 1) {

                    if ($demoModeSpan.text().length == 0) {
                        $demoModeSpan.text('Demo mode');
                    }
                } else {

                    if ($demoModeSpan.text().length > 0) {
                        $demoModeSpan.text('');
                    }
                }

                // show or hide searches remaining and batch records allowed when on batch
                if (winUrl.indexOf('single') != -1 && data.singleUses !== false) {

                    if ($usesLeftEl.length != 0) {

                        $usesLeftEl.text(data.singleUses);

                    } else {

                        var recordsLeftSingle = '<h3 class="panel-title col-lg-6 no-col-pad text-right bold">Searches Remaining: <span id="js-search-uses-left" class="uses-left--span-green">' + data.singleUses + '</span></h3>';

                        // append html
                        $('.panel-heading').first().append(htmlTitle + recordsLeftSingle);
                    }

                } else if (winUrl.indexOf('batch') != -1 && data.batchUses !== false) {

                    if ($usesLeftEl.length != 0) {

                        $usesLeftEl.text(data.batchUses);

                    } else {

                        var recordsLeftBatch = '<h2 class="panel-title col-lg-6 no-col-pad text-right bold">Searches Remaining: <span id="js-search-uses-left" class="uses-left--span-green">' + data.batchUses + '</span></h2>';
                        var recordsPerBatch = '<h2 class="panel-title col-lg-12 no-col-pad text-right bold">Records Per Batch: <span id="js-search-uses-left" class="uses-left--span-green">' + data.batchRecords + '</span></h2>';

                        // append html
                        $('.panel-heading').first().append(htmlTitle + recordsLeftBatch + recordsPerBatch);
                    }

                } else {

                    if ($usesLeftEl.length != 0) {
                        $('.panel-heading').first().empty();
                    }
                }
            }
        });

    });

})(jQuery);